import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

/**
 * Tabla en carga: el marco de la tabla con filas de skeleton, en lugar de un spinner o de un texto
 * "Calculando". Mantiene la altura de las filas (52px, la de DataTable) para que no salte al llegar los datos.
 */
function TablaSkeleton({ filas = 8, columnas = 6, className }: { filas?: number; columnas?: number; className?: string }) {
  return (
    <div className={cn("overflow-hidden rounded-lg border bg-card", className)} aria-busy="true" aria-label="Cargando">
      <div className="flex h-10 items-center gap-4 border-b bg-muted/40 px-4">
        {Array.from({ length: columnas }).map((_, i) => (
          <Skeleton key={i} className="h-3 flex-1" />
        ))}
      </div>
      {Array.from({ length: filas }).map((_, f) => (
        <div key={f} className="flex h-[52px] items-center gap-4 border-b border-border/70 px-4 last:border-b-0">
          {Array.from({ length: columnas }).map((_, c) => (
            <Skeleton key={c} className={cn("h-3.5 flex-1", c === 0 && "max-w-[140px]")} />
          ))}
        </div>
      ))}
    </div>
  );
}

/**
 * Lista con tarjetas en móvil (`md:hidden`) y tabla en escritorio: el conteo de arriba, 4 tarjetas y
 * la tabla con el mismo número de columnas. Nació en Inmobiliaria y Condominio (2026-10-30).
 */
function TablaTarjetasSkeleton({
  columnas,
  filas = 6,
  alturaTarjeta = "h-28",
  sinConteo = false,
}: {
  columnas: number;
  filas?: number;
  alturaTarjeta?: string;
  sinConteo?: boolean;
}) {
  return (
    <div className="space-y-2" aria-busy="true" aria-label="Cargando">
      {!sinConteo && (
        <div className="flex justify-end">
          <Skeleton className="h-4 w-40" />
        </div>
      )}
      <div className="space-y-2 md:hidden">
        {Array.from({ length: 4 }, (_, i) => (
          <Skeleton key={i} className={cn(alturaTarjeta, "w-full rounded-lg")} />
        ))}
      </div>
      <TablaSkeleton filas={filas} columnas={columnas} className="hidden md:block" />
    </div>
  );
}

export { Skeleton, TablaSkeleton, TablaTarjetasSkeleton };
